import { useFormContext } from 'react-hook-form';
import { useFlowsDispatch } from '../../../common/src/utils/globalVariables';
import { updateAnswers } from '../store/redux/slices/flowsSlice';
import { FlowsQuestionAnswer } from '../types/FlowsTypes';

interface UseFlowsLocalAnswer {
  fillAnswers: (arg0: FlowsQuestionAnswer[]) => void;
}

/** Answers the flow locally so no API calls are being done */
const useFlowsLocalAnswer = (): UseFlowsLocalAnswer => {
  const flowsDispatch = useFlowsDispatch();
  const { setValue } = useFormContext();

  const fillAnswers = (answersParam: FlowsQuestionAnswer[]) => {
    let answers;
    if (!Array.isArray(answersParam)) answers = [answersParam];
    else answers = answersParam;
    flowsDispatch(updateAnswers(answers));
    answers.forEach(({ id, answer }) => setValue(id, answer));
  };

  return { fillAnswers };
};

export default useFlowsLocalAnswer;
